'use client'

import Image from 'next/image'

import { FacebookShareButton, TwitterShareButton } from 'react-share'

import useLocale from '@hooks/client/useLocale'
import { getBaseUrl, seoUrlPathEncode } from '@lib/helpers/client'

import facebookSvg from './facebook.svg'
import xSvg from './x.svg'

import styles from './social-share.module.scss'

type SocialShareProps = {
  title?: string
  id?: string
}

export default function SocialShare({ title, id }: SocialShareProps): JSX.Element {
  const locale = useLocale()
  const baseUrl = getBaseUrl()

  return (
    <div className={styles.share}>
      <p>Share</p>
      <FacebookShareButton url={`${baseUrl}/${locale}/blogs/${seoUrlPathEncode(title, 'blog')}-${id}`}>
        <Image src={facebookSvg as string} alt="Facebook" width={15} height={15} />
      </FacebookShareButton>
      <TwitterShareButton url={`${baseUrl}/${locale}/blogs/${seoUrlPathEncode(title, 'blog')}-${id}`}>
        <Image src={xSvg as string} alt="X" width={25} height={25} />
      </TwitterShareButton>
    </div>
  )
}
